import { IColumn } from "cayo.ui";

export const globalSearchDialogColumns: IColumn[] = [
  {
    key: "NameRDN",
    displayName: "Name (RDN)",
    fieldName: "Name",
    columnActionsMode: "disabled",
  },
  {
    key: "Title",
    displayName: "Title",
    fieldName: "Title",
    columnActionsMode: "disabled",
  },
  {
    key: "Office",
    displayName: "Office",
    fieldName: "Office",
    columnActionsMode: "disabled",
  },
  {
    key: "Department",
    displayName: "Department",
    fieldName: "Department",
    columnActionsMode: "disabled",
  },
  {
    key: "DisplayName",
    displayName: "Display Name",
    fieldName: "DisplayName",
    columnActionsMode: "disabled",
  },
  {
    key: "EmailAddress",
    displayName: "E-mail Address",
    fieldName: "mail",
    columnActionsMode: "disabled",
  },
  {
    key: "ParentOU",
    displayName: "Parent OU",
    fieldName: "ParentOU",
    columnActionsMode: "disabled",
  },
];
